import DiscountLabel from './DiscountLabel'

export default DiscountLabel
